import React, { useContext } from 'react'
import { FiShare2 } from 'react-icons/fi'
import { Context } from '../../context/context'

const ShareButton = (props) => {
  const AppContext = useContext(Context)

  const settingShare = () => {
    AppContext.setShare(!AppContext.share)
    AppContext.setUrl(props.url)
  }

  return (
    <div className='click-top-section' onClick={() => settingShare()}>
      <FiShare2 size={25} />
    </div>
  )
}
export default ShareButton
